import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '@/_metronic/helpers'
import {dateStr} from '@/components/utils/date'
import {
  ProductsQueryResponse,
  Product,
  ProductAvailability,
  ProductFilters
} from './_models'

const PRODUCT_URL = '/p2c/product'

export const getProducts = (query: string): Promise<ProductsQueryResponse> => {
  return axios
    .get(`${PRODUCT_URL}?${query}`)
    .then((d: AxiosResponse<ProductsQueryResponse>) => {
      return d.data
    })
}

export const getProduct = (id: ID): Promise<Product | undefined> => {
  return axios
    .get(`${PRODUCT_URL}/${id}`)
    .then((response: AxiosResponse<Response<Product>>) => response.data)
    .then((response: Response<Product>) => response.data)
}

export const getProductAliases = (id: ID): Promise<Array<Product>> => {
  return axios
    .get(`${PRODUCT_URL}/${id}/aliases`)
    .then((response: AxiosResponse<Response<Array<Product>>>) => response.data)
    .then((response: Response<Array<Product>>) => response.data || [])
}

export const copyProduct = (id: ID): Promise<Product | undefined> => {
  return axios
    .post(`${PRODUCT_URL}/${id}/copy`)
    .then((response: AxiosResponse<Response<Product>>) => response.data)
    .then((response: Response<Product>) => response.data)
}

export const getProductFilters = () : Promise<ProductFilters> => {
  return axios
    .get(`${PRODUCT_URL}/filters`)
    .then((d: AxiosResponse<any>) => {
      return d.data.data
    })
}

export const getProductTypes = () : Promise<Array<string>> => {
  return axios
    .get(`${PRODUCT_URL}/types`)
    .then((d: AxiosResponse<any>) => {
      return d.data.data
    })
}

export const getProductStatuses = () : Promise<Array<string>> => {
  return axios
    .get(`${PRODUCT_URL}/statuses`)
    .then((d: AxiosResponse<any>) => {
      return d.data.data
    })
}

export const updateProduct = (data: FormData): Promise<Product|undefined> => {
  return axios
    .put(`${PRODUCT_URL}`, data)
    .then((d: AxiosResponse<Response<Product>>) => d.data)
    .then((d: Response<Product>) => d.data)
}

export const getAvailability = (productId: ID) : Promise<Array<ProductAvailability>> => {
  return axios
    .get(`${PRODUCT_URL}/availability/${productId}`)
    .then((response: AxiosResponse<Response<Array<ProductAvailability>>>) => response.data)
    .then((response: Response<Array<ProductAvailability>>) => response.data || [])
}

export const createAvailability = (productId: ID, data: ProductAvailability) : Promise<any> => {
  return axios
    .post(`${PRODUCT_URL}/availability/${productId}`, data)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

export const updateAvailability = (productId: ID, data: ProductAvailability) : Promise<any> => {
  return axios
    .put(`${PRODUCT_URL}/availability/${productId}`, data)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

export const computeStock = (date: Date) : Promise<string> => {
  return axios
    .get(`${PRODUCT_URL}/stock-at?date=${dateStr(date)}`)
    .then((response: AxiosResponse<string>) => response.data)
    .then((response: string) => response)
}
